import {
  createApiFactory,
  createPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@mainstage/core-plugin-api';
import {
  CustomPresentationRetriever,
  CustomPresentationRetrieverApiRef,
} from './apis';
import {
  DefaultEnvironmentApi,
  environmentApiRef,
} from '@agilelab/plugin-wb-environment';
import {
  InlineScriptNunjucksRenderer,
  wbSafeNunjucksApiRef,
} from './apis/WbSafeNunjucksApi';

export const platformPlugin = createPlugin({
  id: 'platform',
  apis: [
    createApiFactory({
      api: wbSafeNunjucksApiRef,
      deps: {},
      factory: () => new InlineScriptNunjucksRenderer(),
    }),
    createApiFactory({
      api: CustomPresentationRetrieverApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new CustomPresentationRetriever({ discoveryApi, fetchApi }),
    }),
    createApiFactory({
      api: environmentApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new DefaultEnvironmentApi({ discoveryApi, fetchApi }),
    }),
  ],
});
